export function IsJsonString(str) {
  let jsonObj;
  try {
    jsonObj = JSON.parse(str);
  } catch (e) {
    return false;
  }
  return jsonObj;
}
